import CustomerDashboard from "../views/CustomerDashboard";

const CustomerDashboardPage = () => {
  return <CustomerDashboard />;
};

export default CustomerDashboardPage;
